import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import CustomNavbar from "@/components/layouts/CustomNavbar.vue";
import LoadingPage from "@/components/layouts/LoadingPage.vue";
import { useClientStore } from "@/store/ClientStore";
import { storeToRefs } from "pinia";
import { ref, watch, onMounted } from "vue";
import { useRoute } from "vue-router";


const __default__ = {
  name: "Default",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const clientStore = useClientStore();
const { pageLoading } = storeToRefs(clientStore);
const route = useRoute();
const className = ref(null);
onMounted(() => {
  handleRouteChange(route.name);
});
const handleRouteChange = (routeName) => {
  className.value =
    routeName !== "Blog" && routeName !== "BlogShow" ? "background-1" : null;
};
watch(
  () => route.name,
  (val) => {
    handleRouteChange(val);
  }
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["min-vh-100", className.value])
  }, [
    _withDirectives(_createVNode(LoadingPage, null, null, 512), [
      [_vShow, _unref(pageLoading)]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(CustomNavbar),
      _createVNode(_component_router_view)
    ], 512), [
      [_vShow, !_unref(pageLoading)]
    ])
  ], 2))
}
}

})